import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { ContainerCssTokens } from '@youhelp-ru/ui';
import { ComponentType, PropsWithChildren } from 'react';

export const TokenProvider = styled(Box, { name: 'TokenProvider' })(({ theme }) => ({
  [ContainerCssTokens.offset]: theme.spacing(2),
})) as unknown as ComponentType<PropsWithChildren>;
